import {connect} from "react-redux";

import StudentProgress from "../../components/StudentProfile/StudentProgress";
import * as StudentActions from "../../store/actions/studentActions";
import * as RemindersActions from "../../store/actions/remindersActions";
import * as AdminActions from "../../store/actions/adminActions";

const mapStateToProps = (state) => ({
    ...state.reminders,
    ...state.auth,
    ...state.adminInfo,
    ...state.chat
});

const mapDispatchToProps = (dispatch) => ({
    onLoad: (profileId, courseId, token) => {
        //dispatch(AdminActions.getUserCourseContent(courseId, token));
        dispatch(AdminActions.getSingleCourseUser(profileId, courseId, token));
        
        
        dispatch(RemindersActions.getReminders());
    },
    getLocation: () =>{
        dispatch(StudentActions.getLocationStudent())
    },
    getCourseAndLectures: (courseId, token) => {
        dispatch(AdminActions.getCourseAndLectures(courseId, token));
    },
    getCompletedSubjects: (cuid, token) => {
        dispatch(AdminActions.getCompletedSubjects(cuid, token));
    },
    getCompletedLectures: (cuid, token) => {
        dispatch(AdminActions.getCompletedUserLectures(cuid, token));
    },
    getUserLectures: (cuid, token) => {

    },
    getUserSubjects: (cuid, token) => {

    },
    getCurrentSubject: (subjectId, token) => {
        //dispatch(AdminActions.getUserSubject(subjectId, token));
    },
    updateCourseUser: (cu, pid, token) => {
        //dispatch(AdminActions.updateCourseUser(cu, pid, token));
    },
    getVideoQuestions: (id, token) => {
        dispatch(AdminActions.getVideoQuestions(id, token));
    },
    getQuizResults: (id, token) => {
        dispatch(AdminActions.getQuizResults(id, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(StudentProgress);


// WEBPACK FOOTER //
// ./src/containers/StudentProfile/StudentProgressContainer.js